var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g2, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g3, _g4, _path45, _g5, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreetime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    viewBox: "0 0 75 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41785 41.2744H5.22461V46.5205H9.41785V41.2744Z",
    fill: "#676987"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.827 41.313H56.6338V46.5591H60.827V41.313Z",
    fill: "#676987"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5145 41.2739H64.3213V46.52H68.5145V41.2739Z",
    fill: "#676987"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8925 41.313H14.6992V46.5591H18.8925V41.313Z",
    fill: "#676987"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.41785 41.2744H5.22461V46.5205H9.41785V41.2744Z",
    fill: "#42446A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.827 41.313H56.6338V46.5591H60.827V41.313Z",
    fill: "#42446A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.5145 41.2739H64.3213V46.52H68.5145V41.2739Z",
    fill: "#42446A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8925 41.313H14.6992V46.5591H18.8925V41.313Z",
    fill: "#42446A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6914 15.3926H69.2408C70.2429 15.3926 71.2039 15.791 71.9125 16.5001C72.6211 17.2093 73.0191 18.1711 73.0191 19.174V38.5717C73.0191 39.5666 72.6242 40.5208 71.9213 41.2244C71.2183 41.9279 70.2649 42.3231 69.2708 42.3231H58.6914V15.3926Z",
    fill: "#676987"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.6914 15.3926H69.2408C70.2429 15.3926 71.2039 15.791 71.9125 16.5001C72.6211 17.2093 73.0191 18.1711 73.0191 19.174V38.5717C73.0191 39.5666 72.6242 40.5208 71.9213 41.2244C71.2183 41.9279 70.2649 42.3231 69.2708 42.3231H58.6914V15.3926Z",
    fill: "#42446A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5781 7.69873H30.7743V31.8312H7.01074V11.2683C7.01095 10.3215 7.38688 9.41358 8.05587 8.74418C8.72486 8.07478 9.63212 7.69873 10.5781 7.69873Z",
    fill: "#676987"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.6932 7.69873H30.7743V31.8312H7.01074V11.3834C7.01074 10.8995 7.106 10.4203 7.29106 9.97318C7.47613 9.52608 7.74739 9.11985 8.08934 8.77768C8.4313 8.43552 8.83725 8.16412 9.28402 7.97899C9.73078 7.79386 10.2096 7.69863 10.6932 7.69873Z",
    fill: "#42446A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3085_87664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.046 7.69873H35.6278V31.8312H11.8643V11.8832C11.8643 10.7734 12.3048 9.70906 13.0888 8.92432C13.8729 8.13959 14.9364 7.69873 16.0452 7.69873H16.046Z",
    fill: "#676987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5127 7.69873H55.4971C56.5401 7.69873 57.5403 8.11339 58.2778 8.85148C59.0153 9.58957 59.4296 10.5906 59.4296 11.6345V31.8312H35.5127V7.69873Z",
    fill: "#676987"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.332 15.3926H69.2438C70.2454 15.3932 71.2059 15.7919 71.9139 16.5009C72.622 17.21 73.0198 18.1715 73.0198 19.174V38.5717C73.0198 39.5666 72.6248 40.5208 71.9219 41.2244C71.2189 41.9279 70.2655 42.3231 69.2714 42.3231H65.332V15.3926Z",
    fill: "#676987"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3305 34.9785H17.1055V42.3234H65.3305V34.9785Z",
    fill: "#676987"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1872 16.3399L22.9178 17.877C20.5976 18.5539 19.265 20.9849 19.9413 23.307L21.6869 29.3009C22.3631 31.6229 24.7922 32.9566 27.1123 32.2798L32.3818 30.7426C34.7019 30.0658 36.0345 27.6348 35.3583 25.3127L33.6127 19.3188C32.9364 16.9968 30.5074 15.6631 28.1872 16.3399Z",
    fill: "url(#paint0_linear_3085_87664)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8967 17.0556L22.9829 18.489C20.8193 19.1202 19.5766 21.3872 20.2073 23.5526L21.835 29.1418C22.4657 31.3072 24.7308 32.5509 26.8944 31.9198L31.8081 30.4863C33.9717 29.8552 35.2144 27.5882 34.5838 25.4228L32.956 19.8336C32.3254 17.6682 30.0603 16.4245 27.8967 17.0556Z",
    fill: "#FF6584"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.8967 17.0556L22.9829 18.489C20.8193 19.1202 19.5766 21.3872 20.2073 23.5526L21.835 29.1418C22.4657 31.3072 24.7308 32.5509 26.8944 31.9198L31.8081 30.4863C33.9717 29.8552 35.2144 27.5882 34.5838 25.4228L32.956 19.8336C32.3254 17.6682 30.0603 16.4245 27.8967 17.0556Z",
    fill: "#42446A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1506 16.8774L23.2368 18.3108C21.0733 18.942 19.8306 21.209 20.4612 23.3743L22.0889 28.9636C22.7196 31.1289 24.9847 32.3727 27.1483 31.7415L32.062 30.3081C34.2256 29.677 35.4683 27.4099 34.8377 25.2446L33.2099 19.6553C32.5793 17.49 30.3142 16.2463 28.1506 16.8774Z",
    fill: "#FF6584"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0992 21.7028C27.5728 21.3694 27.6867 20.7148 27.3536 20.2408C27.0205 19.7667 26.3664 19.6527 25.8928 19.9861C25.4191 20.3196 25.3052 20.9741 25.6383 21.4482C25.9715 21.9222 26.6255 22.0362 27.0992 21.7028Z",
    fill: "url(#paint1_linear_3085_87664)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1158 24.5851C32.5894 24.2517 32.7033 23.5972 32.3702 23.1231C32.0371 22.6491 31.383 22.5351 30.9094 22.8685C30.4357 23.2019 30.3218 23.8565 30.6549 24.3305C30.9881 24.8045 31.6421 24.9186 32.1158 24.5851Z",
    fill: "url(#paint2_linear_3085_87664)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.065 30.5798C29.5386 30.2464 29.6525 29.5918 29.3194 29.1177C28.9863 28.6437 28.3322 28.5297 27.8586 28.8631C27.3849 29.1965 27.271 29.8511 27.6042 30.3251C27.9373 30.7992 28.5913 30.9132 29.065 30.5798Z",
    fill: "url(#paint3_linear_3085_87664)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.898 21.4165C27.2136 21.1943 27.2895 20.7581 27.0675 20.4422C26.8455 20.1263 26.4097 20.0503 26.094 20.2725C25.7783 20.4947 25.7024 20.9309 25.9244 21.2468C26.1465 21.5627 26.5823 21.6387 26.898 21.4165Z",
    fill: "#FAC7B2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9146 24.2988C32.2302 24.0766 32.3061 23.6404 32.0841 23.3245C31.8621 23.0086 31.4263 22.9326 31.1106 23.1548C30.795 23.377 30.719 23.8132 30.941 24.1291C31.1631 24.4451 31.5989 24.521 31.9146 24.2988Z",
    fill: "#FAC7B2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8638 30.2935C29.1794 30.0713 29.2554 29.6351 29.0333 29.3191C28.8113 29.0032 28.3755 28.9273 28.0598 29.1494C27.7442 29.3716 27.6683 29.8079 27.8903 30.1238C28.1123 30.4397 28.5481 30.5157 28.8638 30.2935Z",
    fill: "#FAC7B2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53269 15.3931H20.9496V42.3236H5.53269C4.43169 42.3236 3.37577 41.886 2.59717 41.1069C1.81858 40.3278 1.38106 39.271 1.38086 38.1691V19.5483C1.38086 18.4463 1.81828 17.3894 2.5969 16.6101C3.37552 15.8309 4.43155 15.3931 5.53269 15.3931Z",
    fill: "#676987"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.56183 15.3931H17.0816C17.5899 15.3931 18.0932 15.4933 18.5628 15.6881C19.0324 15.8829 19.459 16.1684 19.8183 16.5282C20.1776 16.8881 20.4625 17.3153 20.6567 17.7854C20.851 18.2556 20.9508 18.7594 20.9504 19.2681V38.4516C20.9504 39.4785 20.5428 40.4634 19.8172 41.1896C19.0917 41.9157 18.1076 42.3236 17.0816 42.3236H5.56183C4.45297 42.3236 3.38952 41.8828 2.60544 41.098C1.82135 40.3133 1.38086 39.249 1.38086 38.1392V19.5752C1.38147 18.4658 1.82223 17.4021 2.60625 16.6178C3.39027 15.8336 4.45337 15.3931 5.56183 15.3931Z",
    fill: "#42446A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.3008 15.3931H20.0344C20.3802 15.3931 20.7118 15.5306 20.9564 15.7753C21.2009 16.02 21.3383 16.352 21.3383 16.6981V41.0186C21.3383 41.3647 21.2009 41.6967 20.9564 41.9414C20.7118 42.1861 20.3802 42.3236 20.0344 42.3236H13.3008V15.3931Z",
    fill: "#42446A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9131 15.3926H19.6467C19.9925 15.3926 20.3241 15.5301 20.5687 15.7748C20.8132 16.0195 20.9506 16.3515 20.9506 16.6976V41.0182C20.9506 41.3643 20.8132 41.6962 20.5687 41.9409C20.3241 42.1857 19.9925 42.3231 19.6467 42.3231H12.9131V15.3926Z",
    fill: "#676987"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3156 29.3833H19.2031V36.0288H43.3156V29.3833Z",
    fill: "#676987"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M67.467 29.4214H43.3545V36.0669H67.467V29.4214Z",
    fill: "#676987"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.2754 29.3833H21.2434C20.1166 29.3833 19.2031 30.2975 19.2031 31.4252V33.9869C19.2031 35.1146 20.1166 36.0288 21.2434 36.0288H41.2754C42.4022 36.0288 43.3156 35.1146 43.3156 33.9869V31.4252C43.3156 30.2975 42.4022 29.3833 41.2754 29.3833Z",
    fill: "#E3EDF7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1299 17.1606C46.9017 17.1606 47.5274 16.5344 47.5274 15.7619C47.5274 14.9895 46.9017 14.3633 46.1299 14.3633C45.3581 14.3633 44.7324 14.9895 44.7324 15.7619C44.7324 16.5344 45.3581 17.1606 46.1299 17.1606Z",
    fill: "#676987"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.1299 17.1606C46.9017 17.1606 47.5274 16.5344 47.5274 15.7619C47.5274 14.9895 46.9017 14.3633 46.1299 14.3633C45.3581 14.3633 44.7324 14.9895 44.7324 15.7619C44.7324 16.5344 45.3581 17.1606 46.1299 17.1606Z",
    fill: "#42446A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4649 17.1606C25.2367 17.1606 25.8624 16.5344 25.8624 15.7619C25.8624 14.9895 25.2367 14.3633 24.4649 14.3633C23.6931 14.3633 23.0674 14.9895 23.0674 15.7619C23.0674 16.5344 23.6931 17.1606 24.4649 17.1606Z",
    fill: "#676987"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.4649 17.1606C25.2367 17.1606 25.8624 16.5344 25.8624 15.7619C25.8624 14.9895 25.2367 14.3633 24.4649 14.3633C23.6931 14.3633 23.0674 14.9895 23.0674 15.7619C23.0674 16.5344 23.6931 17.1606 24.4649 17.1606Z",
    fill: "#42446A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7648 8.37819C23.958 8.37819 24.1146 8.14346 24.1146 7.85389C24.1146 7.56433 23.958 7.32959 23.7648 7.32959C23.5716 7.32959 23.415 7.56433 23.415 7.85389C23.415 8.14346 23.5716 8.37819 23.7648 8.37819Z",
    fill: "#FAC7B2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M65.4268 29.4214H45.3947C44.2679 29.4214 43.3545 30.3356 43.3545 31.4633V34.025C43.3545 35.1527 44.2679 36.0669 45.3947 36.0669H65.4268C66.5536 36.0669 67.467 35.1527 67.467 34.025V31.4633C67.467 30.3356 66.5536 29.4214 65.4268 29.4214Z",
    fill: "#E3EDF7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.5766 15.968C51.4163 15.086 51.2522 14.194 50.8863 13.3733C50.4856 12.4719 49.8579 11.69 49.0647 11.1042C48.9469 11.0151 48.8009 10.9715 48.6536 10.9814C48.4235 11.0013 48.3529 11.1426 48.3168 11.2884C48.3122 11.3061 48.3084 11.323 48.3053 11.3406C48.2148 11.7882 48.2754 12.2303 48.4066 12.6663C48.5699 13.2106 48.8438 13.741 49.0716 14.2677C49.482 15.2113 49.754 16.2093 49.8792 17.2308C49.8961 17.3659 49.9092 17.5048 49.9122 17.6438C49.9144 17.7265 49.9124 17.8092 49.9061 17.8917C49.8958 18.0535 49.859 18.2125 49.7972 18.3623C49.7864 18.3868 49.7749 18.4124 49.7627 18.439C49.7504 18.4657 49.7371 18.4892 49.7228 18.5097C49.5832 18.74 49.3653 18.9042 49.1521 19.0662C48.9389 19.2282 48.6973 19.4009 48.4426 19.4884H48.4511C48.3326 19.5312 48.2073 19.5518 48.0814 19.5491C47.6879 19.5368 47.2683 19.2197 46.8726 19.2942L46.8281 19.3042C46.4231 19.414 46.1124 20.0511 46.1094 20.4556C46.1094 20.4879 46.1094 20.5191 46.1094 20.5493C46.1094 20.56 46.1094 20.5708 46.1132 20.5815C46.117 20.5923 46.1178 20.6222 46.1209 20.6414C46.124 20.6606 46.1255 20.6652 46.1286 20.6767C46.1316 20.6882 46.1355 20.7113 46.1401 20.7282C46.1447 20.7451 46.147 20.752 46.1508 20.7635C46.1546 20.775 46.1608 20.7949 46.1661 20.8103C46.1715 20.8257 46.1753 20.8333 46.1799 20.8441C46.1845 20.8548 46.1922 20.8732 46.1991 20.8871L46.216 20.9193C46.2237 20.9324 46.2306 20.9462 46.239 20.9592L46.2589 20.9899L46.285 21.0268L46.3073 21.0552L46.3372 21.089L46.3617 21.1151L46.3947 21.1465L46.4215 21.1703L46.4576 21.1995L46.486 21.2218L46.5251 21.2486L46.5542 21.2686L46.5972 21.2939L46.6271 21.3108L46.6754 21.3346L46.7038 21.3484C46.7268 21.3592 46.7506 21.3691 46.7744 21.3784L46.8089 21.3914L46.8641 21.4114L46.904 21.4236L46.9493 21.4375L46.9937 21.449L47.0367 21.4597L47.0842 21.4697L47.1257 21.4782L47.1755 21.4866L47.2154 21.4927L47.2668 21.4996L47.3051 21.5043L47.3588 21.5089H47.3964H47.4516H47.4869H47.5445H47.6649H47.7278H47.75L47.8175 21.5035H47.8305C48.022 21.4868 48.2105 21.4453 48.3912 21.3799C48.9642 21.1626 49.4505 20.7658 49.9007 20.3489C50.7935 19.5237 51.6372 18.4997 51.7086 17.2853C51.7362 16.8469 51.6556 16.4048 51.5766 15.968Z",
    fill: "url(#paint4_linear_3085_87664)"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.8009 15.6763H40.5703V17.7712H47.8009V15.6763Z",
    fill: "#42446A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8009 15.6763H40.5703V17.5808H47.8009V15.6763Z",
    fill: "#676987"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7565 15.93C45.3869 15.93 45.8979 15.4186 45.8979 14.7878C45.8979 14.1569 45.3869 13.6455 44.7565 13.6455C44.1262 13.6455 43.6152 14.1569 43.6152 14.7878C43.6152 15.4186 44.1262 15.93 44.7565 15.93Z",
    fill: "#676987"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6046 16.5458L42.5908 16.532C42.6167 16.5124 42.6377 16.487 42.6522 16.4579C42.6666 16.4288 42.6742 16.3967 42.6742 16.3642C42.6742 16.3317 42.6666 16.2997 42.6522 16.2706C42.6377 16.2415 42.6167 16.2161 42.5908 16.1965L42.6031 16.1812C42.6308 16.2027 42.6532 16.2303 42.6687 16.2618C42.6841 16.2933 42.6921 16.328 42.6921 16.3631C42.6921 16.3982 42.6841 16.4328 42.6687 16.4644C42.6532 16.4959 42.6308 16.5235 42.6031 16.545L42.6046 16.5458Z",
    fill: "#E3EDF7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.6046 16.5458L42.5908 16.532C42.6167 16.5124 42.6377 16.487 42.6522 16.4579C42.6666 16.4288 42.6742 16.3967 42.6742 16.3642C42.6742 16.3317 42.6666 16.2997 42.6522 16.2706C42.6377 16.2415 42.6167 16.2161 42.5908 16.1965L42.6031 16.1812C42.6308 16.2027 42.6532 16.2303 42.6687 16.2618C42.6841 16.2933 42.6921 16.328 42.6921 16.3631C42.6921 16.3982 42.6841 16.4328 42.6687 16.4644C42.6532 16.4959 42.6308 16.5235 42.6031 16.545L42.6046 16.5458Z",
    fill: "#42446A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.591 16.5455C42.5633 16.524 42.5408 16.4964 42.5254 16.4649C42.51 16.4333 42.502 16.3987 42.502 16.3636C42.502 16.3285 42.51 16.2938 42.5254 16.2623C42.5408 16.2308 42.5633 16.2032 42.591 16.1816L42.6033 16.197C42.5774 16.2166 42.5563 16.242 42.5419 16.2711C42.5274 16.3002 42.5199 16.3322 42.5199 16.3647C42.5199 16.3972 42.5274 16.4293 42.5419 16.4584C42.5563 16.4875 42.5774 16.5128 42.6033 16.5325L42.591 16.5455Z",
    fill: "#E3EDF7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4378 22.6915C48.9616 22.4927 49.4057 22.1296 49.8184 21.7488C50.6345 20.995 51.4046 20.06 51.4705 18.9492C51.4943 18.5439 51.4214 18.1401 51.3486 17.7402C51.2021 16.9341 51.0525 16.1189 50.7204 15.3697C50.3542 14.5463 49.7807 13.8321 49.056 13.297C48.9481 13.2154 48.8143 13.1756 48.6794 13.1849C48.4493 13.2057 48.391 13.3638 48.3603 13.515C48.1739 14.4362 48.6855 15.3297 49.0598 16.1895C49.4348 17.0517 49.6833 17.9636 49.7977 18.897C49.846 19.2931 49.8636 19.7214 49.655 20.0623C49.5277 20.2711 49.3283 20.4231 49.1334 20.5705C48.842 20.7908 48.5198 21.0218 48.1547 21.0111C47.7896 21.0003 47.3816 20.6864 47.0042 20.7877C46.6269 20.889 46.35 21.4701 46.3477 21.8425C46.3431 22.8511 47.7367 22.9571 48.4378 22.6915Z",
    fill: "#FAC7B2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.653 20.0625C49.5257 20.2713 49.3263 20.4233 49.1315 20.5707C48.9365 20.7318 48.7175 20.8613 48.4826 20.9545C48.8139 20.9323 49.1107 20.7243 49.38 20.5178C49.5748 20.3704 49.7742 20.2176 49.9015 20.0096C50.1094 19.6695 50.0925 19.2419 50.0442 18.8443C49.9298 17.9109 49.6813 16.999 49.3063 16.1368C48.932 15.2763 48.4197 14.382 48.6068 13.4623C48.612 13.408 48.6283 13.3552 48.6547 13.3074C48.6811 13.2596 48.717 13.2178 48.7602 13.1844C48.7319 13.182 48.7034 13.182 48.6751 13.1844C48.445 13.2052 48.3867 13.3633 48.356 13.5145C48.1696 14.4357 48.6812 15.3292 49.0555 16.189C49.4305 17.0512 49.679 17.9631 49.7934 18.8965C49.844 19.2934 49.8617 19.7217 49.653 20.0625Z",
    fill: "#42446A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.5969 21.792C46.5969 21.4481 46.8416 20.9253 47.1707 20.7687C47.1146 20.7673 47.0585 20.7738 47.0042 20.7879C46.6338 20.8885 46.35 21.4704 46.3477 21.8427C46.3431 22.7838 47.5542 22.9373 48.2867 22.7401C47.5588 22.846 46.5923 22.6303 46.5969 21.792Z",
    fill: "#42446A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.2551 11.2992C41.2551 11.2992 43.3444 10.8809 44.3891 11.2992C44.3891 11.2992 45.0157 9.83532 45.6424 9.83532C46.269 9.83532 46.4776 12.1383 46.4776 12.1383L47.3129 15.4837C47.3129 15.4837 51.2822 22.5928 47.3129 26.3558C43.3436 30.1188 37.0771 25.9352 37.0771 23.2169C37.0771 20.4987 38.3304 14.8542 38.3304 14.8542C38.3304 14.8542 39.5837 10.2545 40.0018 9.83609C40.4198 9.41772 41.2551 11.2992 41.2551 11.2992Z",
    fill: "url(#paint5_linear_3085_87664)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3262 11.59C41.3262 11.59 43.3342 11.1877 44.3382 11.59C44.3382 11.59 44.9403 10.1829 45.5432 10.1829C46.1461 10.1829 46.3463 12.3937 46.3463 12.3937L47.1493 15.6094C47.1493 15.6094 50.9652 22.4414 47.1493 26.0609C43.3335 29.6803 37.3086 25.6586 37.3086 23.0463C37.3086 20.434 38.5136 15.0067 38.5136 15.0067C38.5136 15.0067 39.7185 10.5851 40.1205 10.1829C40.5224 9.78061 41.3262 11.59 41.3262 11.59Z",
    fill: "#FAC7B2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.5517 19.366C48.2436 18.0596 47.7714 16.7975 47.1465 15.6099L47.273 16.118C47.8171 17.1504 48.2459 18.2396 48.5517 19.366Z",
    fill: "#E3EDF7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.6695 22.5049C37.6695 19.8949 38.6413 15.5147 38.6413 15.5147C38.6413 15.5147 39.8463 11.0931 40.2482 10.6909C40.6501 10.2886 41.4532 12.0979 41.4532 12.0979C41.4532 12.0979 43.4612 11.6957 44.4652 12.0979C44.4652 12.0979 45.0681 10.6909 45.6702 10.6909C45.9003 10.6909 46.0775 11.024 46.2017 11.4316C46.079 10.8352 45.8704 10.1827 45.5437 10.1827C44.9416 10.1827 44.3387 11.5898 44.3387 11.5898C43.3347 11.1875 41.3266 11.5898 41.3266 11.5898C41.3266 11.5898 40.5236 9.78119 40.1217 10.1827C39.7198 10.5842 38.5148 15.0066 38.5148 15.0066C38.5148 15.0066 37.543 19.3821 37.543 21.9967C37.5422 22.2332 37.6695 22.5802 37.6695 22.5049Z",
    fill: "#E3EDF7"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2418 15.5096C45.4637 15.5096 45.6437 15.3295 45.6437 15.1073C45.6437 14.8852 45.4637 14.7051 45.2418 14.7051C45.0198 14.7051 44.8398 14.8852 44.8398 15.1073C44.8398 15.3295 45.0198 15.5096 45.2418 15.5096Z",
    fill: "#42446A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6236 15.5096C40.8456 15.5096 41.0255 15.3295 41.0255 15.1073C41.0255 14.8852 40.8456 14.7051 40.6236 14.7051C40.4016 14.7051 40.2217 14.8852 40.2217 15.1073C40.2217 15.3295 40.4016 15.5096 40.6236 15.5096Z",
    fill: "#42446A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0328 15.9119C43.3653 15.9119 43.6349 15.7318 43.6349 15.5097C43.6349 15.2875 43.3653 15.1074 43.0328 15.1074C42.7002 15.1074 42.4307 15.2875 42.4307 15.5097C42.4307 15.7318 42.7002 15.9119 43.0328 15.9119Z",
    fill: "#42446A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2333 14.6041L46.4258 15.0059L46.4693 15.2022L48.2769 14.8005L48.2333 14.6041Z",
    fill: "#FAC7B2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4362 15.408L46.4277 15.8086L46.467 16.0058L48.4754 15.6053L48.4362 15.408Z",
    fill: "#FAC7B2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2455 14.0086L37.1709 14.1953L39.1792 14.9992L39.2538 14.8125L37.2455 14.0086Z",
    fill: "#FAC7B2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6243 15.0097L36.5938 15.2085L39.2046 15.6107L39.2352 15.4119L36.6243 15.0097Z",
    fill: "#FAC7B2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9852 16.4224C41.6399 19.5697 38.5596 16.6527 38.5596 16.6527L46.9852 16.4224Z",
    fill: "#FAC7B2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7444 38.9404L38.0225 42.196L40.7009 43.3444L42.4228 39.7065L39.7444 38.9404Z",
    fill: "#FAC7B2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7008 43.3444L40.8917 44.1121C40.8917 44.1121 44.3356 46.6015 43.5701 47.1757C42.8047 47.7499 35.5342 44.1121 35.5342 44.1121L38.0216 42.1968L40.7008 43.3444Z",
    fill: "#42446A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.2396 40.0441L39.5298 39.1406L38.7236 40.6636L41.402 41.8128L42.2396 40.0441Z",
    fill: "#42446A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9795 32.8422L54.5659 35.4629L56.4642 33.2498L53.5128 30.5146L51.9795 32.8422Z",
    fill: "#FAC7B2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.464 33.2489L57.2517 33.2958C57.2517 33.2958 60.6572 30.7541 60.9756 31.6568C61.2939 32.5596 55.6456 38.4121 55.6456 38.4121L54.5664 35.4628L56.464 33.2489Z",
    fill: "#42446A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9424 13.6542L35.917 9.04834C36.0586 8.88447 36.1312 8.67201 36.1195 8.45568C36.1077 8.23935 36.0126 8.03601 35.8541 7.88843L27.2053 1.32812L26.1553 2.96782L32.8582 8.13177L30.0126 11.2546L31.9424 13.6542Z",
    fill: "#FAC7B2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.4853 9.64307L30.0947 11.1691L32.0268 13.5719L34.021 11.2643C33.0482 10.9561 32.1737 10.3969 31.4853 9.64307Z",
    fill: "#42446A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4024 14.6538L15.9024 11.2762C15.6277 11.07 15.4406 10.7679 15.3782 10.43C15.3159 10.0921 15.3827 9.74308 15.5656 9.45226L22.2992 1.95312L23.6798 3.33489L19.0218 9.14213L21.7754 11.898L20.4024 14.6538Z",
    fill: "#FAC7B2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.4502 13.9737L20.1865 14.5264L21.5671 11.7705L19.8337 10.041C19.8705 10.6275 19.9741 12.9066 19.4502 13.9737Z",
    fill: "#42446A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2385 28.0298L38.1074 40.4326L42.2385 41.8106L49.1225 28.0298L43.6153 26.6519L42.2385 28.0298Z",
    fill: "#E3EDF7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.29 1.96122C22.29 1.96122 24.0542 -0.315617 25.3941 1.2166C26.7341 2.74883 23.2895 2.93997 23.2895 2.93997L22.29 1.96122Z",
    fill: "#FAC7B2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3389 25.2742L25.6696 27.9387C26.0839 28.768 26.7484 29.4458 27.569 29.8761C28.3896 30.3064 29.3247 30.4673 30.2418 30.3361L46.3689 28.0331L51.8768 34.9235L56.0072 30.7898L47.1214 23.167C46.8843 22.9636 46.6074 22.812 46.3083 22.722C46.0093 22.632 45.6947 22.6055 45.3849 22.6443L24.3389 25.2742Z",
    fill: "#E3EDF7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0362 10.0254C20.0362 10.0254 20.4021 14.5007 19.0215 14.6535L21.7751 16.0353C21.7751 16.0353 21.6216 24.15 24.5286 27.0594C24.5286 27.0594 29.8831 24.15 35.5437 24.3036C41.2042 24.4571 34.163 18.7911 34.163 18.7911L33.2334 12.5179L34.0004 11.3664C32.9634 11.0556 32.035 10.4583 31.322 9.64307C30.555 10.6003 28.8016 11.8984 27.2807 11.8984H26.6226C24.3553 11.8984 21.9438 11.2482 20.0332 10.0254H20.0362Z",
    fill: "#C25435"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6641 8.76367V10.299C23.6642 11.0787 23.9737 11.8264 24.5246 12.3778L27.7952 15.651L28.8836 13.4716C29.0732 13.0922 29.1719 12.6738 29.172 12.2496V8.76367H23.6641Z",
    fill: "#FAC7B2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.7061 10.5359C23.7061 10.5927 23.7061 10.6488 23.7114 10.7056C24.4689 11.3817 25.4486 11.755 26.4636 11.7541C27.4785 11.7533 28.4576 11.3784 29.214 10.701V8.99756H23.7061V10.5359Z",
    fill: "#42446A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4175 11.52C28.6986 11.52 30.5478 9.66924 30.5478 7.38622C30.5478 5.1032 28.6986 3.25244 26.4175 3.25244C24.1363 3.25244 22.2871 5.1032 22.2871 7.38622C22.2871 9.66924 24.1363 11.52 26.4175 11.52Z",
    fill: "#FAC7B2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.664 6.22027H30.5487C30.5487 6.22027 33.3023 3.46442 30.5487 2.08649C29.9508 1.80134 29.3245 1.58006 28.6803 1.42631C24.4931 0.363891 20.5116 3.82981 21.05 8.11942C21.1774 9.13272 21.5402 9.96177 22.2872 10.354C25.1934 11.8832 23.664 6.22027 23.664 6.22027Z",
    fill: "#42446A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.664 6.02886H30.5487C30.5487 6.02886 33.3023 3.27301 30.5487 1.89508C29.9508 1.60994 29.3245 1.38866 28.6803 1.23491C24.4931 0.172485 20.5116 3.63841 21.05 7.92801C21.1774 8.94131 21.5402 9.77036 22.2872 10.1626C25.1934 11.6941 23.664 6.02886 23.664 6.02886Z",
    fill: "#42446A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.7588 15.9617L21.9505 15.3867L22.5243 15.7698L21.7588 15.9617Z",
    fill: "#42446A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.1743 18.792C34.1743 18.792 32.0911 19.7899 31.5166 20.7495L34.1743 18.792Z",
    fill: "#42446A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.2388 12.5146L33.0478 13.0888L32.665 12.5146H33.2388Z",
    fill: "#42446A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.664 6.02886H30.5487C30.5487 6.02886 33.3023 3.27301 30.5487 1.89508C29.9508 1.60994 29.3245 1.38866 28.6803 1.23491C24.4931 0.172485 20.5116 3.63841 21.05 7.92801C21.1774 8.94131 21.5402 9.77036 22.2872 10.1626C25.1934 11.6941 23.664 6.02886 23.664 6.02886Z",
    fill: "#42446A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0234 21.4211C42.0234 21.4211 43.4202 24.4602 41.5862 24.722C39.7523 24.9837 40.5891 22.1765 40.5891 22.1765C40.5891 22.1765 40.4058 21.3413 39.9609 21.2944",
    fill: "#FAC7B2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0026 21.3047C44.0026 21.3047 42.3389 24.2087 44.1452 24.6263C45.9515 25.0439 45.364 22.1798 45.364 22.1798C45.364 22.1798 45.6202 21.3669 46.0697 21.3592",
    fill: "#FAC7B2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3085_87664",
    x: 11.8643,
    y: 7.69873,
    width: 47.5654,
    height: 26.1323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3085_87664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3085_87664",
    x1: 5832.08,
    y1: -34104.9,
    x2: 3982.63,
    y2: -36732.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3085_87664",
    x1: 853.592,
    y1: -4948.92,
    x2: 820.585,
    y2: -4995.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3085_87664",
    x1: 996.526,
    y1: -4870.65,
    x2: 963.507,
    y2: -4917.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3085_87664",
    x1: 914.073,
    y1: -4700.06,
    x2: 881.054,
    y2: -4746.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3085_87664",
    x1: 4264.73,
    y1: 3586.17,
    x2: 4264.73,
    y2: 2140.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3085_87664",
    x1: 8156.55,
    y1: 7639.77,
    x2: 8156.55,
    y2: 3382.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreetime);
export default __webpack_public_path__ + "static/media/Freetime.b31f0a703100c6b02d03d18665852674.svg";
export { ForwardRef as ReactComponent };